import { useState } from 'react';
import styled from 'styled-components/macro';
import { message } from 'antd';
import { fetchSchemeTemplate, SchemeSummary, SchemeTemplate } from '../../../../feature/schemeTemplates';

interface CopyFromSchemeProps {
  schemes: SchemeSummary[];
  onCopy: (template: SchemeTemplate, scheme: SchemeSummary) => void;
}

export default function CopyFromScheme({ schemes, onCopy }: CopyFromSchemeProps) {
  const [loading, setLoading] = useState(false);

  if (schemes.length === 0) return null;

  const onChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    const scheme = schemes.find((s) => s.id === event.target.value);
    if (!scheme) return;

    setLoading(true);
    try {
      onCopy(await fetchSchemeTemplate(scheme.id), scheme);
    } catch {
      message.error('Could not load that scheme. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrap>
      <Label htmlFor="copy-from-scheme">Copy from existing scheme</Label>
      <Select id="copy-from-scheme" aria-label="Copy from existing scheme" defaultValue="" onChange={onChange} disabled={loading}>
        <option value="" disabled>{loading ? 'Loading…' : 'Choose a scheme to copy its description and agreement'}</option>
        {schemes.map((s) => (
          <option key={s.id} value={s.id}>{s.schemeName}</option>
        ))}
      </Select>
      <Hint>The description and contribution agreement are copied into the editors below, ready to edit.</Hint>
    </Wrap>
  );
}

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 24px;
`;

const Label = styled.label`
  font-weight: 600;
  font-size: 14px;
  color: #1F1F1F;
`;

const Select = styled.select`
  max-width: 471px;
  padding: 9px 12px;
  font-size: 14px;
  color: #1F1F1F;
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  background: #fff;
`;

const Hint = styled.span`
  font-size: 12px;
  color: #909DA8;
`;
